import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DiagnosticsApp from './components/DiagnosticsApp';

const DiagnosticsAppPage: React.FC = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/rc/err/:messageId`} component={DiagnosticsApp} />
            <Route path={path} component={DiagnosticsApp} />
        </Switch>
    );
};

export default DiagnosticsAppPage;
